import React from 'react';
import { TabsContent } from '../../ui/tabs';
import { Label } from '../../ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';

const PRHeaderTab = ({ formData, handleHeaderChange, masterData }) => (
  <TabsContent value="header">
    <Card>
      <CardHeader>
        <CardTitle>PR Header - General Information</CardTitle>
        <CardDescription>Document control fields only (per SAP ER diagram)</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="bg-orange-50 p-4 rounded-md mb-4">
          <p className="text-sm text-orange-800">
            <strong>Note:</strong> Per SAP standards, the PR Header contains only Document Type, PR Number (auto-generated), and Source Determination. All other information (requester, delivery, organizational data) is specified at the item level.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Document Type *</Label>
            <select
              value={formData.document_type}
              onChange={(e) => handleHeaderChange('document_type', e.target.value)}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm"
              required
            >
              {masterData.documentTypes.map((dt) => (
                <option key={dt.document_type_id} value={dt.document_type_id}>
                  {dt.document_type_id} - {dt.description}
                </option>
              ))}
            </select>
          </div>
          <div className="flex items-center space-x-2 pt-6">
            <input
              type="checkbox"
              id="source_determination"
              checked={formData.source_determination}
              onChange={(e) => handleHeaderChange('source_determination', e.target.checked)}
              className="h-4 w-4"
            />
            <Label htmlFor="source_determination" className="cursor-pointer">Source Determination</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  </TabsContent>
);

export default PRHeaderTab;
